module.exports = __webpack_public_path__ + "webStatic/img/douyin.4f699a81.png";